import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
// @ts-ignore
import GeslubSession from "geslub-platform-session";

import { SYSTEM } from "./configs";
import { ROUTES } from "./utils/constants";
import { AppProps } from "./utils/types/containers";
import { Home, Analysis, Projections } from "./containers";
import {
  MainNavbar,
  ModalScreen,
  Dialog,
  SampleAnalysisFrame,
} from "./components";
import { setUserLoaded, setInitLocation } from "./redux/reducers/auth";
import { setOpen } from "./redux/reducers/modalScreen";
import { setAuthToken } from "./services/axios";

const sessionProps =
  SYSTEM.ENV !== "production"
    ? {
        domain: "localhost",
        apiURL: SYSTEM.PLATFORM_BACKEND_BASE_URL,
        loginURL: SYSTEM.LOGIN_URL,
        redirect: SYSTEM.URL,
      }
    : { redirect: SYSTEM.URL };

const Session = new GeslubSession(sessionProps);

const App = ({
  userIsAuthenticated,
  onLoadUser,
  isModalOpen,
  modalContent,
  onSetOpenModal,
  globalDialogProps,
  onSetInitLocation,
  userLogged,
}: AppProps): React.ReactElement | undefined => {
  const [isLoadingUser, setIsLoadingUser] = useState<boolean>(true);

  const { pathname, search, href } = window.location;

  useEffect(() => {
    if (Session.isSession()) {
      loadUser();
      return;
    }
    // TODO quitar /frame para cuando tribolab se integre con Geslub.cl
    if (pathname.indexOf("frame") !== -1) setIsLoadingUser(false);
    else window.location.href = Session.getLoginURL({ shouldRedirect: true });
  }, []);

  const loadUser = async () => {
    const session = Session.getSession();
    const user = await Session.getUser();
    onSetInitLocation({ search, pathname, href });
    onSetOpenModal(true);
    setAuthToken(session.authToken);

    onLoadUser(user);

    onSetOpenModal(false);
    setIsLoadingUser(false);
  };

  const handleLogout = () => {
    Session.removeSession();
    window.location.href = Session.getLoginURL();
  };

  if (isLoadingUser) return <div>Cargando...</div>;

  if (
    userLogged?.plataformas?.dashboard?.autorizacion !== true &&
    pathname.indexOf("frame") === -1
  ) {
    window.location.href = Session.getLoginURL();
    return <div>Sin autorización...</div>;
  }

  return (
    <>
      <Router basename={SYSTEM.BASE_URL}>
        <Switch>
          {
            // TODO incluir ruta de Frame dentro de las rutas privadas
          }
          <Route
            exact
            path={ROUTES.FRAME_SAMPLE_ANALYSIS}
            component={SampleAnalysisFrame}
          />

          {userIsAuthenticated && (
            <>
              <Route path={ROUTES.APP}>
                <MainNavbar onLogout={handleLogout} user={userLogged}>
                  <Switch>
                    <Route
                      exact
                      path={ROUTES.APP}
                      render={() => <Redirect to={ROUTES.HOME} />}
                    />
                    <Route exact path={ROUTES.HOME} component={Home} />
                    <Route
                      exact
                      path={ROUTES.PROJECTIONS}
                      component={Projections}
                    />
                    <Route exact path={ROUTES.ANALYSIS} component={Analysis} />
                    <Route>Pagina no encontrada.</Route>
                  </Switch>
                </MainNavbar>
              </Route>

              <Route render={() => <Redirect to={ROUTES.APP} />} />
            </>
          )}
        </Switch>
      </Router>

      <ModalScreen open={isModalOpen} testId="global-modal">
        {modalContent}
      </ModalScreen>
      <Dialog {...globalDialogProps} />
    </>
  );
};

const mapStateToProps = (state: Record<string, Record<string, any>>) => ({
  userIsAuthenticated: state.auth.isAuthenticated,
  userLogged: state.auth.user,
  isModalOpen: state.modalScreen.open,
  modalContent: state.modalScreen.content,
  globalDialogProps: state.globalDialog.props,
});

const mapDispatchToProps = (dispatch: (fn: any) => any) => ({
  onLoadUser: (user: any) => dispatch(setUserLoaded(user)),
  onSetOpenModal: (value) => dispatch(setOpen(value)),
  onSetInitLocation: (location) => dispatch(setInitLocation(location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
